import { useQuery } from '@tanstack/react-query'

import { CAR_QUERY_KEYS } from '@/entities/car/lib'
import { withSessionRetry } from '@/shared/lib/webviewBridge'

import { getAllMacar } from '../request/carApis'

import type { IMacar } from '@/entities/car/model'

/** ⚠️ 'use client' 금지. entities/car 배럴을 Edge 라우트가 끌어가서 빌드가 깨진다 */

/** 내 차량은 예약 한 번 하는 동안 바뀌지 않는다 */
const MY_CARS_STALE_TIME_MS = 5 * 60 * 1000

/** 로그인한 사용자의 차량 목록. 타이어(신규 브릿지)만 써서 401 이면 토큰을 받아 다시 부른다 */
const useMyCarsQuery = () =>
  useQuery<IMacar[]>({
    queryKey: CAR_QUERY_KEYS.MACAR.list(),
    queryFn: () => withSessionRetry(getAllMacar),
    staleTime: MY_CARS_STALE_TIME_MS,
    gcTime: MY_CARS_STALE_TIME_MS,
    refetchOnWindowFocus: false,
    throwOnError: false,
    retry: false,
  })

export default useMyCarsQuery
